import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import {
  generatePartnerPlanViaService,
  generatePdfPartnerPlanViaAppDes,
  TPartnerPlanExportFormats,
  TPartnerPlanPdfVersion,
} from 'legacy/lut/classes/services/partner360/ExportCommitmentService'

interface IGeneratePartnerPlan {
  partnerId: string
  fYear: number
  programType: ProgramTypes
  shouldGeneratePDFOnBackend: boolean
  extension: TPartnerPlanExportFormats
  pdfVersion?: TPartnerPlanPdfVersion
}

export const generatePartnerPlan = async ({
  partnerId,
  fYear,
  programType,
  shouldGeneratePDFOnBackend,
  extension,
  pdfVersion,
}: IGeneratePartnerPlan) => {
  // App Designer generates the default PDF only; PPTX, JSON and a versioned PDF must always use the service.
  if (shouldGeneratePDFOnBackend || extension !== 'PDF' || pdfVersion) {
    return generatePartnerPlanViaService({
      pid: partnerId,
      fYear,
      exportFormat: extension,
      programType: programType,
      openResultInNewTab: true,
      pdfVersion,
    })
  }
  return generatePdfPartnerPlanViaAppDes({
    pid: partnerId,
    fYear,
    programType: programType,
    preventDownload: false,
  })
}
